import { render, staticRenderFns } from "./pictureInfo.vue?vue&type=template&id=2a31ca7b&scoped=true&"
import script from "./pictureInfo.vue?vue&type=script&lang=js&"
export * from "./pictureInfo.vue?vue&type=script&lang=js&"
import style0 from "./pictureInfo.vue?vue&type=style&index=0&id=2a31ca7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31ca7b",
  null
  
)

export default component.exports